import {WinPresentationController} from "../WinPresentationController";
import {RockBottomParsedGameData} from "../../server/data/RockBottomParsedGameData";
import {RockBottom} from "../../RockBottom";
import {ReelState} from "../../../core/reel/ReelState";
import {ScatterNudgeView} from "./ScatterNudgeView";
import {RockBottomSymbol} from "../../symbol/RockBottomSymbol";
import {RockBottomParsedInitData} from "../../server/data/RockBottomParsedInitData";
import {RockBottomGameMode} from "../../server/RockBottomGameMode";
import {RockBottomSound} from "../../sound/RockBottomSound";
import {MathHelper} from "../../../core/utils/MathHelper";

export class ScatterNudgeController extends WinPresentationController {
    private readonly _nudgeStepDurationNormal: number = 0.5;
    private readonly _nudgeStepDurationSkipped: number = 0.01;
    private readonly _nudgeEase: string = `elastic.out(1, 1)`;
    private _view: ScatterNudgeView;
    private _hasWin: boolean = false;

    constructor() {
        super("ScatterNudgeController", true);
        this._view = new ScatterNudgeView();
        this.checkOnRestore();
    }

    public getScatterSymbolInReel(reelId: number): number {
        for (let index: number = 1; index < 5; index++) {
            if (RockBottom.model.reels[reelId][index] === "S") {
                return index;
            }
        }
        return -1;
    }

    protected hasWin(): boolean {
        const data: RockBottomParsedGameData = RockBottom.model.parsedGameData;
        this._hasWin = (data.nextMode !== RockBottomGameMode.WINCAP_PICK && data.nudgeSteps.filter(x => x > 0).length > 0) && !(RockBottom.inBonusGame);
        return this._hasWin;
    }

    protected async createWinAnimation(): Promise<void> {
        const data: RockBottomParsedGameData = RockBottom.model.parsedGameData,
            nudgeData: number[] = data.nudgeSteps,
            promises: Promise<void>[] = [];

        let delay = 0;

        nudgeData.forEach((nudgeSteps: number, reelId) => {
            if (nudgeSteps > 0) {
                const promise = new Promise<void>(resolve => {
                        RockBottom.reels[reelId].nudge(
                            nudgeSteps,
                            this._hasWin ? this._nudgeStepDurationNormal : this._nudgeStepDurationSkipped,
                            this._nudgeEase,
                            delay,
                            (stepsLeft: number, aborted: boolean) => this.onNudgeStepStart(reelId, stepsLeft, aborted),
                            (stepsLeft: number, aborted: boolean) => this.onNudgeStepComplete(reelId, stepsLeft, aborted),
                            async (aborted: boolean) => {
                                await this.onReelNudgeComplete(reelId, aborted);
                                resolve();
                            },
                            false
                        );
                        delay += this._hasWin ? this.getNextReelNudgeDelayDelta(reelId) : this._nudgeStepDurationSkipped;
                    }
                );
                promises.push(promise);
            }
        });

        await Promise.all(promises);
    }

    protected skip() {
        let playAbortSound: boolean = false;
        RockBottom.reels.forEach(reel => {
            if (reel.reelState === ReelState.NUDGE) {
                reel.abortNudge();
                playAbortSound = true;
            }
        });
        if (playAbortSound) {
            // playAbortSound();
        }
    }

    protected getNextReelNudgeDelayDelta(reelId: number): number {
        return Math.abs(RockBottom.model.parsedGameData.nudgeSteps[reelId]) * this._nudgeStepDurationNormal;
    }

    private checkOnRestore(): void {
        const initData: RockBottomParsedInitData = RockBottom.model.parsedInitData;
        if (initData.isRestoreState && (initData.mode === RockBottomGameMode.NORMAL && (initData.nextMode === RockBottomGameMode.FREESPIN || initData.nextMode === RockBottomGameMode.SUPER_FREESPIN))) {
            const nudgeData: number[] = initData.nudgeSteps;
            nudgeData.forEach((nudgeSteps: number, reelId) => {
                if (nudgeSteps > 0) {
                    RockBottom.reels[reelId].nudge(
                        nudgeSteps, this._nudgeStepDurationSkipped, this._nudgeEase, 0,
                        (stepsLeft: number, aborted: boolean) => this.onNudgeStepStart(reelId, stepsLeft, aborted),
                        (stepsLeft: number, aborted: boolean) => this.onNudgeStepComplete(reelId, stepsLeft, aborted),
                        async (aborted: boolean) => {
                            this.onReelNudgeComplete(reelId, aborted);
                        },
                        true
                    );
                }
            });
        }
    }

    private plusOneSpinDisplay(reelNo: number, noOfNudge: number): void {
        let symbol: RockBottomSymbol = RockBottom.reels[reelNo].getSymbol(this.getScatterSymbolInReel(reelNo));
        let positions: PIXI.Point = symbol.getGlobalPosition();
        if (!RockBottom.model.isRestore) {
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SPIN_COUNT_PLUS_1});
        }
        this._view.showAddFreespin(positions, noOfNudge);
    }

    private onNudgeStepStart(reelId: number, stepsLeft: number, aborted: boolean): void {
        let randomNo: number = MathHelper.uniqueNumberInRange(1, 3);
        if (!RockBottom.model.isRestore) {
            RockBottomSound.soundPlayer.playTrack({name: `nudge${randomNo}`});
        }
        this.plusOneSpinDisplay(reelId, stepsLeft);
        if(!(RockBottom.inBonusGame)) {
            RockBottom.freeSpinView.updateSpinsCounter(undefined, false, true);
        }
        //console.log(`Reel ${reelId} start nudge step, stepsLeft = ${stepsLeft}, abort = ${aborted}`);
    }

    private onNudgeStepComplete(reelId: number, stepsLeft: number, aborted: boolean): void {
        //console.log(`Reel ${reelId} completed nudge step, stepsLeft = ${stepsLeft}, abort = ${aborted}`);
    }

    private onReelNudgeComplete(reelId: number, aborted: boolean): void {
        //console.log(`Reel ${reelId} completed reel nudge, abort = ${aborted}`);
    }
}